import {initApplication} from "./initApp";
import {App} from "./app";

initApplication(App);